<template>
    <div>
        <div class="leaderBox" v-if="showOrhide">
            <div class="newtext">新手指引</div>
            <img src="../../../assets/images/maskClose.png" class="closeIt" @click="closeIt">
            <img src="../../../assets/images/pop/tjlb/tjlb1.jpg" class="steps step1" v-if="status==1">
            <img src="../../../assets/images/pop/tjlb/tjlb2.jpg" class="steps step2" v-if="status==2" >
            <div class="stepbtn" @click="nextStep(status)">
                {{status==1?"下一步":status==2?"我知道了":"我知道了"}}
            </div>
            <div class="bottomTip">
                <el-checkbox v-model="checked">下次不再提示</el-checkbox>
            </div>
        </div>
        <!--        <breadcrumb :routerList="[{to:'/pricenewN',title:'特价管理'},{title:'特价列表'}]"/>-->
        <Breadtabsheader/>
        <div class="h-content">
            <div class="h-piece">
                <div class="h-formBox zhi">
                    <el-form :inline="true" :model="formInline" class="demo-form-inline h-formBorder">

                        <div class="h-thirdColumn w-newColumn">

                            <el-form-item label="区域" prop="areaCode">
                                <brselect category="YLRegion" :v="formInline.areaCode" v-model="formInline.areaCode"
                                          :clearable="true" :multiple="true"
                                          style="width:100%"/>
                            </el-form-item>

                        </div>
                    </el-form>
                    <div class="l-screenBox">
                        <div class="l-retrieval">
                            <el-button class="h-btn h-formBtn" @click="handleFilter">检索</el-button>
                            <el-button class="h-btn h-formBtn h-bgwhite" @click="resetData">重置</el-button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="h-row T-jia">
                <div class="h-rowIn" style="width:100%;">
                    <div class="h-rowTitle h-pdl0">
                        <div class="h-el-tab">
                            <ul>
                                <li :class="{ 'h-active': indx == 0 }" @click="tabIndex('月累计')"><a>月累计</a></li>
                                <li :class="{ 'h-active': indx == 1 }" @click="tabIndex('年累计')"><a>年累计</a></li>
                            </ul>
                        </div>
                    </div>
                    <el-table
                            ref="multipleTable"
                            :data="tableData2"
                            border
                            stripe
                            max-height="450"
                    >
                        <el-table-column
                                type="selection"
                                width="45"
                                label="全选"
                                fixed
                        >
                        </el-table-column>
                        <el-table-column
                                type="index"
                                width="50"
                                fixed
                                label="#">
                        </el-table-column>
                        <el-table-column
                                prop="areaName"
                                label="区域"
                                :show-overflow-tooltip="true"
                                width="150"
                        >
                            <template slot-scope="scope" >
                                {{scope.row.areaName}}
                            </template>
                        </el-table-column>
                        <!-- 遍历T+3到T+8周周列信息,分多级表头,第一级表头是周信息,第二级表头为周包含日信息 -->
                        <el-table-column
                                v-for="(monthInfo,index) in monthList"
                                :key = "'monthColIndex'+index"
                                :label="monthInfo.columnMonthName"
                        >
                            <el-table-column
                                    v-for="(detailInfo,detailIndex) in monthInfo.trends"
                                    :key = "monthInfo.key+'weekDayColIndex'+detailIndex"
                                    :label="detailInfo.columnName" width="110"
                                    :prop="detailInfo.key"
                            >
                            </el-table-column>
                        </el-table-column>
                    </el-table>
                </div>
            </div>
            <div class="h-tableB h-mrt30" style="padding-right: 0.12rem;">
                <div class="h-tableBL">
                    <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import" @click="exportExcel">批量导出</el-button>
                </div>
                <div class="h-pagination2 h-pageCenter">
                    <pagination :page="formInline" @query="query"/>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import ss from '../../../api/SystemService'
    import uploaddownexcel from '../../../components/uploaddown/uploaddownexcel'
    import updownfile from '../../../utils/updownfile'
    export default {
        components: {
            uploaddownexcel,
            updownfile,
        },
        data() {
            return {
                closeScreen:require("@/assets/images/pimg/closeallic.png"),
                drawScreen:require("@/assets/images/pimg/dobleArr.png"),
                tableData2:[],
                formInline: {
                    areaCode:null,//区域
                    searchType:null,//0,月累计;1,年累计
                    pageSize: 10,
                    pageNo: 1,
                    total: 0,
                },
                uploaddownexcelflag:false,
                showOrhide:false,
                updateVisDialogFlag:false,
                uptitleDig: null,
                authCode:null,
                detailList:[],
                monthList:[],
                item:null,
            }
        },
        //加载页面默认执行
        created() {
            this.formInline.searchType = '0';
            this.query();
            this.getTableHeader();
            // this.getUserAuth();
        },
        mounted() {

        },
        methods: {
            /*// 展开折叠
            collapseChange(){
                this.isScreen = !this.isScreen;
            },*/
            showzhezhao(){
                ss.salesList.toshow(this.toshow).then(rd => {
                    console.log(rd)
                    if(rd == false){
                        this.showOrhide = false;
                    }else{
                        this.showOrhide = true;
                    }
                })
            },
            //重置
            resetData(){
                this.formInline.categorys = null;
                this.formInline.field = null;
                this.formInline.daquCode = null;
                this.formInline.soldToAreaCode = null;
                this.formInline.customerChannelCode = null;
            },
            //检索
            query(){
                let _self = this;
                ss.resourcePool.getAreaForecast(this.formInline).then(rd => {
                    this.tableData2 = rd.records;
                    this.formInline.total = rd.total;
                    for (let i = 0; i < this.tableData2.length; i++) {
                        let areaForecast = this.tableData2[i];
                        for (let j = 0; j < areaForecast.trends.length; j++) {
                            const monthData = areaForecast.trends[j];
                            _self.$set(areaForecast, monthData.key, monthData.income);
                            console.log("areaForecast",areaForecast)
                        }
                    }
                })
            },

            getTableHeader(){
                ss.resourcePool.getTableHeader().then(rd =>{
                    this.monthList = rd;
                })
            },

            //明细导出
            exportExcel() {
                updownfile.down("/api/swyl/v1/bscAreaForecastTrend/downloadExcel",this.formInline,"post",'data');
            },
            dateFormatter(v){
                var now = new Date(v);
                var year=now.getFullYear();
                var month = now.getMonth()+1 < 10?'0'+(now.getMonth()+1) : now.getMonth()+1;
                var alldata2 =  year+"-"+month;
                return alldata2;
            },
            formatDate(row, column) {
                // 获取单元格数据
                let data = row[column.property]
                if(data == null || data == '') {
                    return null
                }
                let dt = new Date(data)
                return this.$util.riQi3(dt);
            },
            // 展开折叠
            collapseChange(){
                this.isScreen = !this.isScreen;
            },
            //检索
            handleFilter() {
                this.formInline.pageNo = 1;
                this.query();
            },
            //获取表头信息
            getResourceData(v){
                var data = {};
                data.field = v;
                data.specialCategory = this.formInline.categorys;
                ss.resourcePool.getTotalResourceData(data).then(rd => {
                    if(rd.f){
                        this.detailList= rd.msg;
                    }
                })
            },
            //全部/已转化/为转化标签
            tabIndex(i) {
                this.item = i;
                if (this.item == '月累计') {
                    this.formInline.searchType = 0;
                    this.indx = 0;
                    this.query();
                } else if (this.item == '年累计') {
                    this.formInline.searchType = 1;
                    this.indx = 1;
                    this.query();
                }
            },
        }
    }
</script>
<style scoped>
    .selectorBox {
        width: 100%;
        padding: 0.54rem 0.28rem 0 0.25rem;
    }
    .selectorBox .text {
        margin-left: 0.38rem;
        font-size: 0.18rem;
        color: #4a4a4a;
        position: relative;
    }
    .selectorBox .text::before {
        content: "*";
        position: absolute;
        top: 0;
        left: -7px;
        color: red;
        font-size: 0.2rem;
    }
    .selectorBox .selector {
        margin-left: 0.38rem;
        margin-top: 20px;
        display: flex;
    }
    .selectorBox .selector .button {
        width: 65px;
        padding: 10px;
        color: #b7b7b7;
        border: 1px solid #dcdfe1;
        text-align: center;
        line-height: 20px;
        cursor: pointer;
    }
    .selectorBox .selector .button.active {
        color: #fff;
        background: #238cfd;
        border: 1px solid #238cfd;
    }
    .T-jia .h-btn.el-button.h-tableLink{
        padding: 0 0.05rem;
    }
    #xcv {
        padding: 0.14rem 0.2rem;
        font-size: 0.18rem;
        color: #fff;
        letter-spacing: 0.02rem;
        border: 1px solid #24b5b8;
        background: #24b5b8;
        border-radius: 0.04rem;
        line-height: 0.18rem;
    }
</style>
<style>
    .X-la .h-formbLine .el-form-item__content .el-select{
        width: 100%!important;
    }
    .zhi .el-date-editor .el-range-separator{
        width:13%;
        margin-bottom:7px;
    }
    .selectorBox .el-input-group__append {
        background: #238cfd;
        color: #fff
    }
    .selectorBox .el-upload-list {
        display: none;
    }

</style>
<style scoped lang="scss">
    .bottomTip{
        position: absolute;
        left: 49.7%;
        bottom: 0.3rem;
        transform: translateX(-50%);
        z-index: 999999;
    }
    .newtext{
        font-size: 0.28rem;
        color: white;
        position: absolute;
        top:0.2rem;
        left: 50%;
        transform: translateX(-50%);
        font-weight: bold;
        text-shadow:1px 1px 4px #2785E7;
        z-index: 2;
    }
    .leaderBox{
        width: 100%;
        height: 100%;
        background-color: rgba(0,0,0,0.4);
        position: fixed;
        z-index: 99999;
        overflow: hidden;
        top: 0;
        left: 0;
        .leaderbg{
            width: 100%;
            height: 100%;

        }
        .steps{
            position: absolute;
            z-index: 1;

        }
        .step1{
            top: 0;
            left: 0;

        }
        .step2{
            top: 0;
            right: 0;
        }
        .stepbtn{
            width: 1.9rem;
            height: 0.6rem;
            border: 0.03rem solid #FFFFFF;
            background-color: rgba(0,0,0,0.1);
            border-radius: 5px;
            display: flex;
            justify-content: center;
            line-height: 0.5rem;
            position: absolute;
            z-index: 99;
            bottom: 0.75rem;
            left: 50%;
            transform: translateX(-50%);
            font-size: 0.27rem;
            letter-spacing: 2px;
            color: white;
            cursor: pointer;
        }
        .closeIt{
            width: 0.3rem;
            height: 0.3rem;
            position: absolute;
            top: 0.2rem;
            right: 0.2rem;
            cursor: pointer;
            z-index: 2;
        }
    }
</style>
